import React from 'react';

import PageTitle from '@/components/common/PageTitle/PageTitle';
import Page from '@/components/Page/Page';
import { upliftTabs } from './tabs';
import TagTabs from '@/components/common/TagTabs/TagTabs';
import { useAddQueryToUrl } from '@/components/common/TagTabs/useAddQueryToUrl';


const DEFAULT_TAB = 'UPLIFT-TOOL';
export default function UpliftsManager() {
  const { getValue } = useAddQueryToUrl();
  const activeTab = getValue('tab') ?? DEFAULT_TAB;


  return (
    <Page
      padding={true}
      pageTitle="Uplifts Manager"
    >
      <PageTitle title="Uplifts Manager" />
      <div className="mt-10">
        <TagTabs tabs={upliftTabs} activeTabKey={activeTab} cacheMode="after-select" />
      </div>
    </Page >
  );
}
